import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // window 스크롤
        window.scrollTo(0, 0);

        // ⭐ overflow-y-auto인 내부 스크롤 컨테이너도 초기화
        const scrollContainers = document.querySelectorAll('.overflow-y-auto');
        scrollContainers.forEach(el => {
            el.scrollTop = 0;
        });
    }, [pathname]);

    return null;
}